import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { InfoBlock } from '@marvelapp/ballpark-components';
import { Box } from '@marvelapp/ui';
// eslint-disable-next-line mobx/missing-observer
export default function ErrorBox({ children, }) {
    return (_jsx(Box, { pl: "s", pb: "s", pr: "s", width: "100%", "data-testid": "media-share-error", children: _jsx(InfoBlock, { kind: "warning", bg: "tomato5", color: "yellow", fontWeight: "semibold", maxWidth: "none", children: _jsx(Box, { children: children }) }) }));
}
